import { useState } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '@/components/ui/dialog';

export const ReferenceInfoDialog = ({ id, title, description, trigger, children, primaryTo, primaryLabel }) => {
  const [open, setOpen] = useState(false);
  return <Dialog open={open} onOpenChange={setOpen}>
    <DialogTrigger asChild>{trigger}</DialogTrigger>
    <DialogContent data-testid={`${id}-dialog`} className="reference-info-dialog">
      <DialogClose asChild><Button variant="ghost" size="icon" data-testid={`${id}-dismiss`} aria-label="Cerrar ventana" className="reference-dialog-dismiss"><X /></Button></DialogClose>
      <DialogHeader><DialogTitle data-testid={`${id}-title`}>{title}</DialogTitle><DialogDescription data-testid={`${id}-description`}>{description}</DialogDescription></DialogHeader>
      {children}
      <DialogFooter>
        <Button data-testid={`${id}-close`} variant="outline" onClick={() => setOpen(false)} className="reference-dialog-secondary">Cerrar</Button>
        {primaryTo && <Button asChild className="reference-dialog-primary"><Link data-testid={`${id}-primary`} to={primaryTo} onClick={() => setOpen(false)}>{primaryLabel || 'Ver productos'}</Link></Button>}
      </DialogFooter>
    </DialogContent>
  </Dialog>;
};
